import { PropsWithChildren } from "react"

import { useStableNavigate } from "~/ui-rtk/utils/StableNavigateContext"
import { brandRoutes, guestRoutes } from "~/ui-rtk/constants/routes"
import useAccess from "~/ui-rtk/hooks/access"
import UpgradePage from "~/ui-rtk/pages/Upgrade"

type TSubscriptionGuardProps = {
  /** Pages included in the free Share of Search tier (e.g. the SoS report). */
  sosFreeAllowed?: boolean
}

export default function SubscriptionGuard({
  children,
  sosFreeAllowed,
}: PropsWithChildren<TSubscriptionGuardProps>) {
  const { isBillingEnabled, hasAccess, isSosFree } = useAccess()

  const navigate = useStableNavigate()

  // Must run BEFORE the hasAccess check: ACL deliberately grants SOS_FREE
  // companies blanket isAccessGranted (so PagePermissionGuard lets them into
  // Main and the report deep link resolves) — this branch is what scopes that
  // access down to the SoS surface, showing the upsell everywhere else
  // (APP-453). isSosFree is false for super admins.
  if (isSosFree) {
    return sosFreeAllowed ? children : <UpgradePage />
  }

  if (hasAccess) {
    return children
  }

  if (isBillingEnabled) {
    navigate(guestRoutes.UPGRADE)
  } else {
    navigate(brandRoutes.SETUP.CONNECTORS)
  }

  return null
}
